import React from "react";
import { NavLink } from "react-router-dom";

const HomeProduct = ({ product }) => {
  const { title, details, img, size, price, _id } = product;

  return (
    <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col border border-gray-100 hover:-translate-y-1">
      {/* Image Container with Zoom Effect */}
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-50">
        <img
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
          src={img}
          alt={title}
        />
        {/* Overlay gradient for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Price Badge */}
        <span className="absolute top-4 left-4 bg-white/95 backdrop-blur text-slate-900 text-sm font-bold px-3.5 py-1.5 rounded-full shadow-sm ring-1 ring-black/5">
          {price}
        </span>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-1">
        <div className="flex justify-between items-start mb-3 gap-2">
          <h3 className="text-xl font-bold text-slate-900 line-clamp-1 group-hover:text-amber-500 transition-colors duration-200">
            {title}
          </h3>
          <span className="bg-amber-50 text-amber-700 text-xs font-bold px-2.5 py-1 rounded-md whitespace-nowrap shrink-0 border border-amber-100 shadow-sm">
            {size}
          </span>
        </div>
        
        <p className="text-slate-500 leading-relaxed line-clamp-2 flex-1 mb-6 text-sm">
          {details}
        </p>
        
        <NavLink
          to={`/products/${_id}`}
          className="flex items-center justify-center gap-2 w-full py-3 bg-slate-900 text-white text-center rounded-xl text-sm font-semibold hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
        >
          View Pet Details
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </NavLink>
      </div>
    </div>
  );
};

export default HomeProduct;
